import { Grid } from "@material-ui/core";
import { QualityCheckSection } from "./components/quality-check-section/quality-check-section";
import { FileUploader } from "../files";
import { ReferenceList } from "@consultants/consultant-profile-new/references/reference-list";

type QualityChecksTabProps = {
  consultantId: string;
};

export function QualityChecksTab({ consultantId }: QualityChecksTabProps) {
  return (
    <Grid container spacing={1}>
      <Grid item xs={8}>
        <ReferenceList consultantId={consultantId} />
        <br/>
        <FileUploader consultantId={consultantId} />
      </Grid>
      <Grid item xs={4}>
        <QualityCheckSection consultantId={consultantId} />
      </Grid>
    </Grid>
  );
}
